import { Component, Input } from '@angular/core';
import { ProductCarouselTeaser } from '~app/modules/storyblok/models';
import { environment } from '~env/environment';
import {
  GATrackingEventType,
  GaTrackingEventAction,
  GaTrackingEventCategory,
} from '~shared/modules/ga-tracking/constants';
import { GtmDatalayerService } from '~shared/services/gtm-datalayer.service';
import { COLOR_OPTIONS } from '../../../constants';
import { getCountryDomainCode } from '~server/utils/country-detection.util';

@Component({
  selector: 'app-teaser',
  templateUrl: './teaser.component.html',
  styleUrls: ['./teaser.component.scss'],
})
export class TeaserComponent {
  @Input() teaser: ProductCarouselTeaser;
  @Input() isMobile: boolean;
  @Input() isLongText: boolean;

  readonly mediumTextLengthIndicator = 14;

  market: string;
  private readonly marketplaceLink = environment.appBaseUrl();

  get isMediumText(): boolean {
    return this.teaser?.text?.length > this.mediumTextLengthIndicator || false;
  }

  constructor(private gtmDataLayerService: GtmDatalayerService) {
    this.market = getCountryDomainCode();
  }

  fireTeaserEvent(): void {
    this.gtmDataLayerService.gtagEvent({
      category: GaTrackingEventCategory.Interaction,
      action: GaTrackingEventAction.productCarouselTeaserClick,
      event: GATrackingEventType.productCarouselTeaserClick,
      label: this.teaser?.link,
    });
  }

  colorSelector(): string {
    return COLOR_OPTIONS[this.teaser?.color] || COLOR_OPTIONS['primaryBlue'];
  }

  navigateTo(): void {
    this.fireTeaserEvent();
    window.location.href = this.marketplaceLink + this.teaser?.link;
  }
}
